"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
var BoardContainer_1 = require("./BoardContainer");
var GameVars_1 = require("../../../GameVars");
var GameConstants_1 = require("../../../GameConstants");
var Item_1 = require("./Item");
var BoardManager_1 = require("../BoardManager");
var Utils_1 = require("../../../utils/Utils");
var AudioManager_1 = require("../../../AudioManager");
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(scene, x, y) {
        var _this = _super.call(this, scene) || this;
        _this.x = x;
        _this.y = y;
        _this.f = 0;
        _this.itemUndetermined = true;
        _this.onDown = false;
        _this.n = GameVars_1.GameVars.modeGameData.iMaxItemUncovered;
        var textureAtlas;
        var textureName;
        if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
            textureAtlas = "texture_atlas_2";
            textureName = "cake_" + _this.n;
        }
        else {
            textureAtlas = "texture_atlas_3";
            textureName = "biscuits_" + _this.n;
        }
        _this.bck = new Phaser.GameObjects.Graphics(_this.scene);
        _this.bck.fillStyle(0x000000);
        _this.bck.alpha = 0;
        _this.bck.fillRect(-GameVars_1.GameVars.gameWidth * 5, -GameVars_1.GameVars.gameHeight * 5, GameVars_1.GameVars.gameWidth * 10, GameVars_1.GameVars.gameHeight * 10);
        _this.bck.setInteractive(new Phaser.Geom.Rectangle(-GameVars_1.GameVars.gameWidth * 5, -GameVars_1.GameVars.gameHeight * 5, GameVars_1.GameVars.gameWidth * 10, GameVars_1.GameVars.gameHeight * 10), Phaser.Geom.Rectangle.Contains);
        _this.bck.on("pointerdown", function () {
            _this.onClickBack();
        }, _this);
        _this.add(_this.bck);
        var cellBck = new Phaser.GameObjects.Image(_this.scene, 0, 20, "texture_atlas_1", GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "base" : "base_2");
        _this.add(cellBck);
        _this.itemImage = new Phaser.GameObjects.Image(_this.scene, 0, 0, textureAtlas, textureName);
        _this.itemImage.setScale(Item_1.Item.ITEM_SCALE);
        _this.add(_this.itemImage);
        _this.frame = new Phaser.GameObjects.Image(_this.scene, 0, 10, "texture_atlas_1", "frame_gift");
        _this.add(_this.frame);
        return _this;
    }
    Carousel.prototype.update = function () {
        if (this.itemUndetermined) {
            this.f++;
            if (this.f % 4 === 0) {
                // cambiar la imagen
                this.n = this.n > GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 3 ? this.n - 1 : GameVars_1.GameVars.modeGameData.iMaxItemUncovered;
                if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
                    this.itemImage.setFrame("cake_" + this.n);
                }
                else {
                    this.itemImage.setFrame("biscuits_" + this.n);
                }
            }
            if (this.f === 90) {
                this.itemUndetermined = false;
                this.n = GameVars_1.GameVars.modeGameData.boardConfiguration[GameVars_1.GameVars.coverPosition.r][GameVars_1.GameVars.coverPosition.c].n;
                if (GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1) {
                    this.itemImage.setFrame("cake_" + this.n);
                }
                else {
                    this.itemImage.setFrame("biscuits_" + this.n);
                }
                this.onItemDetermined();
            }
        }
    };
    Carousel.prototype.destroy = function () {
        var _this = this;
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 200,
            delay: GameVars_1.GameVars.rewardValue ? 500 : 0,
            onComplete: function () {
                _super.prototype.destroy.call(_this);
            },
            onCompleteScope: this
        });
        if (GameVars_1.GameVars.rewardValue) {
            setTimeout(function () {
                var mergeEffect = new Phaser.GameObjects.Sprite(_this.scene, 0, 0, "texture_atlas_1", "fx_merge_01");
                _this.scene.add.existing(mergeEffect);
                mergeEffect.play("merge-fx");
                mergeEffect.setScale(1.5);
                _this.add(mergeEffect);
            }, 250);
        }
    };
    Carousel.prototype.onItemDetermined = function () {
        if (GameVars_1.GameVars.isVideoRewardAvailable) {
            this.viewVideoButton = new Utils_1.Button(this.scene, 0, 110, "texture_atlas_1", "btn_upgrade_off", "btn_upgrade_on");
            this.viewVideoButton.alpha = 0;
            this.viewVideoButton.setScale(1 / BoardContainer_1.BoardContainer.currentInstance.scaleX);
            this.viewVideoButton.onDown(this.onClickVideoButton, this);
            this.add(this.viewVideoButton);
            this.scene.tweens.add({
                targets: this.viewVideoButton,
                alpha: 1,
                y: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 300
            });
            this.scene.tweens.add({
                targets: this.bck,
                alpha: .5,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 300
            });
        }
        else {
            var t = 700;
            var glowImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "radial2_new_cake_mistery_box");
            glowImg.blendMode = Phaser.BlendModes.SCREEN;
            glowImg.setScale(0);
            this.addAt(glowImg, 0);
            this.scene.tweens.add({
                targets: glowImg,
                scaleX: 3.25,
                scaleY: 3.25,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: t * .35,
                delay: 500,
                yoyo: true
            });
            this.scene.tweens.add({
                targets: this.frame,
                alpha: 0,
                scaleX: 1.35,
                scaleY: 1.35,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: t,
                delay: 500,
                onComplete: function () {
                    BoardManager_1.BoardManager.onMysteriousItemDetermined(this.n);
                },
                onCompleteScope: this
            });
            this.scene.tweens.add({
                targets: this.itemImage,
                y: this.itemImage.y - 10,
                scaleX: 1.125 * Item_1.Item.ITEM_SCALE,
                scaleY: 1.125 * Item_1.Item.ITEM_SCALE,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 350,
                yoyo: true,
                delay: 500
            });
        }
        AudioManager_1.AudioManager.playSound("cake_special_revealed_after_spins");
    };
    Carousel.prototype.onClickVideoButton = function () {
        if (this.onDown) {
            return;
        }
        this.onDown = true;
        this.viewVideoButton.visible = false;
        var w = window;
        if (w.gdsdk !== "undefined" && w.gdsdk.showAd !== "undefined") {
            GameVars_1.GameVars.rewardValue = this.n + 1;
            GameVars_1.GameVars.modeGameData.boardConfiguration[GameVars_1.GameVars.coverPosition.r][GameVars_1.GameVars.coverPosition.c].n = this.n + 1;
            w.gdsdk.showAd("rewarded");
        }
        else {
            BoardManager_1.BoardManager.onMysteriousItemDetermined(this.n);
        }
    };
    Carousel.prototype.onClickBack = function () {
        if (this.onDown) {
            return;
        }
        this.onDown = true;
        BoardManager_1.BoardManager.onMysteriousItemDetermined(this.n);
    };
    return Carousel;
}(Phaser.GameObjects.Container));
exports.Carousel = Carousel;
